import {useLazyQuery} from '@apollo/client';
import {userQueries} from 'api/graphql-queries';
import {UserInfoResponseModel, UserInfoQueryFilterRequest} from 'models/userInfoFilter.model';

export const useGetAllUsersByBoardId = () => {
    const [refetch, {data, loading}] = useLazyQuery<
        {allUserInfos: UserInfoResponseModel[]},
        UserInfoQueryFilterRequest
    >(userQueries.ALL_USERS_BY_FILTER, {
        fetchPolicy: 'no-cache',
    });

    return {
        allUsersByBoardIdResponse: data?.allUserInfos,
        allUsersByBoardIdLoading: loading,
        getAllUsers: refetch,
    };
};
